import { Box, Stack } from '@mui/material';
import React, { FC, Fragment, useContext, useEffect, useState } from 'react';
import { getRandomStringFromArr } from '../../../Utils/StringUtils';
import CharBox from './CharBox';

// Define the interface for the component's props
interface ComboCharRowProps {
  index: number;
  gameChars: string[];
  winningPairs: string[];
  charCombo: string;
  onPlayerTapHandler: () => void;
}

// Functional Component using props and state
const ComboCharRow: FC<ComboCharRowProps> = ({
  index,
  gameChars,
  winningPairs,
  charCombo,
  onPlayerTapHandler,
}) => {
  const chars = charCombo.split('');

  // console.log('index::: ', index);

  const [currentChar1, setCurrentChar1] = useState(
    getRandomStringFromArr(gameChars)
  );

  const [currentChar2, setCurrentChar2] = useState(
    getRandomStringFromArr(gameChars)
  );

  const onCharClickHandler = () => {
    setCurrentChar1(getRandomStringFromArr(gameChars));
    setCurrentChar2(getRandomStringFromArr(gameChars));
  };

  console.log(
    'Row: ' + index + ' - ' + chars[0] + ',' + chars[1],
    '=',
    currentChar1 + ',' + currentChar2
  );
  return (
    <>
      <Stack
        direction="row"
        spacing={2}
        //justifyContent="center"
        //alignItems="center"
        onClick={() => {
          onCharClickHandler();
          onPlayerTapHandler();
        }}
      >
        {/* {chars.map((char) => ( */}
        <CharBox
          index={0}
          row={index}
          correctChar={chars[0]}
          currentChar={currentChar1}
          winningPairs={winningPairs}
          gameChars={gameChars}
        />
        <CharBox
          index={1}
          row={index}
          correctChar={chars[1]}
          currentChar={currentChar2}
          winningPairs={winningPairs}
          gameChars={gameChars}
        />
        {/* // ))} */}
      </Stack>
    </>
  );
};

export default ComboCharRow;
